const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoltrona = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 119.75 98.75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "15.62 81.22 13.38 98.38 6.43 98.38 6.43 81.22 15.62 81.22",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.43 81.22 107.67 98.38 114.62 98.38 114.62 81.22 105.43 81.22",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.38,
    y: 0.38,
    width: 101,
    height: 81,
    rx: 18.11,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13,25.88h-5.51a6.24,6.24,0,0,0-6.24,6.24V66h-83V32.12a6.24,6.24,0,0,0-6.25-6.24H6.62A6.24,6.24,0,0,0,.38,32.12v43a6.24,6.24,0,0,0,6.24,6.25h5.51c.15,0,.29,0,.44,0a1.52,1.52,0,0,0,.21,0H107a1.52,1.52,0,0,0,.21,0c.15,0,.29,0,.44,0h5.51a6.25,6.25,0,0,0,6.25-6.25v-43A6.24,6.24,0,0,0,113.13,25.88Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.55,
    y: 48.37,
    width: 98.8,
    height: 18,
    rx: 4.6,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoltrona);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/poltrona.ca86848dbc5dbc425e2492bf809a73e5.svg";